import React from 'react';
import { Icons } from '../../../assets/SvgIcons';
import { useTranslation } from 'react-i18next';

export default function EmptyElement() {
  const { t } = useTranslation();
  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Icons.NoItem />
      </div>
      <div style={{}}>
        <div
          style={{
            color: '#1C174D',
            fontWeight: 600,
            fontSize: 20,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: 15,
          }}
        >
          {t('dashboard.nothing_here_to_show')}
        </div>
        <div
          style={{
            color: '#1C174D',
            fontWeight: 400,
            fontSize: 14,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {t('dashboard.there_are_no_items')}
        </div>
      </div>
    </div>
  );
}
